module.exports = __webpack_public_path__ + "static/esther-bc1dfe6d90d5afc88f362b4a67d797a2.jpg";